/**
 * Email campaign option sets + colors.
 *
 * Status is driven by the send pipeline lifecycle
 * (draft → scheduled → sending → sent / partially_failed / failed / canceled),
 * not editable freely inline.
 *
 * Brand options are DERIVED from the canonical marketing brand registry
 * (MARKETING_BRANDS + getBrandConfig, see MARKETING_BRANDS rule) so this config
 * can never drift from the DB enum.
 */


export const EMAIL_CAMPAIGN_STATUS_OPTIONS = [
  { label: "Draft", value: "draft", color: "gray" },
  { label: "Scheduled", value: "scheduled", color: "blue" },
  { label: "Sending", value: "sending", color: "indigo" },
  { label: "Sent", value: "sent", color: "green" },
  { label: "Partially Failed", value: "partially_failed", color: "amber" },
  { label: "Failed", value: "failed", color: "red" },
  { label: "Canceled", value: "canceled", color: "orange" },
] as const;

/** Brand options derived from the canonical marketing brand registry. */
/**
 * Empty by design — injected at render time by `useEmailCampaignsConfigEnhancer`.
 * See the note on SOCIAL_POST_BRAND_OPTIONS: brands are data, not a build-time
 * union, so a static list here would go stale the moment one is onboarded.
 */
export const EMAIL_CAMPAIGN_BRAND_OPTIONS: { label: string; value: string }[] = [];

/** Statuses that mean the campaign has not yet fully sent (NOT terminal). */
export const PENDING_SEND_STATUSES = ["draft", "scheduled", "sending"] as const;

/** Terminal statuses that indicate the campaign send has completed (any outcome). */
export const SENT_STATUSES = ["sent", "partially_failed", "failed"] as const;
